import { z } from 'zod';
import { ValidatorUtils } from '../utils/ValidatorUtils';
import { CampaignEnumSchema } from './sharedSchemas';

export const UnauthedAccessRequestSchema = z.object({
    attributes: z.object({
        campaign: CampaignEnumSchema,
        origin: z.string().url().max(256)
            .transform((s) => ValidatorUtils.sanitizeString(s)),
        resumeToken: z.string().min(100).max(400)
            .transform((s) => ValidatorUtils.sanitizeString(s))
            .optional(),
        enableSherlock: z.boolean().default(false),
        enableSurvey: z.boolean().default(true),
    }),
});
